
import Phaser from 'phaser';
import BootScene from './scenes/boot';

function launch() {
  return new Phaser.Game({
    type: Phaser.AUTO,
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: '100%',
      height: '100%',
    },
    // scale: {
    //   mode: Phaser.Scale.RESIZE,
    //   width: "100%",
    //   height: "100%"
    // },
    transparent: true,
    parent: 'game-type-picker',
    scene: [BootScene],
  });
}

export { launch };
